<template>
    <div class="page" id="proProfile">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2 green_dark">
            <header>
                <h2>Your profile</h2>

                <empty-placeholder class="mt30 warning">
                    IMPORTANT: This information appears in your Players accounts and on the Lesson
                    Pro website, please make sure it is accurate.
                </empty-placeholder>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <button
                v-if="!editMode"
                @click.prevent="editMode = true"
                class="button mb20"
                type="button"
                name="button"
            >
                Edit
            </button>

            <form class="form3" v-if="editMode" @submit.prevent="saveForm">
                <div class="formGroup">
                    <img
                        v-if="image1"
                        style="max-width: 100%; margin-bottom: 10px; border-radius: 12px"
                        :src="image1"
                    />
                    <img
                        v-else-if="form.image"
                        style="max-width: 100%; margin-bottom: 10px; border-radius: 12px"
                        :src="imageURL(form.image)"
                    />

                    <div style="position: relative">
                        <android-file-picker
                            id="content-profile-image"
                            mode="single"
                            type="Image"
                            v-if="androidFilePickerOpen"
                        ></android-file-picker>
                        <label class="button fileInput" @click="openFileAndroid">
                            <input @change="addImage" type="file" />
                            {{ form.image ? "Change image" : "Add Image" }}
                            <img class="arrow" src="@/assets/arrow-plus-white.svg" />
                        </label>
                    </div>
                </div>
                <div class="formGroup">
                    <label>Qualifications</label>
                    <textarea-autosize
                        v-model="form.qualifications"
                        :min-height="30"
                        maxlength="1000"
                    />
                </div>

                <div class="formGroup">
                    <label>Specialisms</label>
                    <textarea-autosize
                        v-model="form.specialisms"
                        :min-height="30"
                        maxlength="1000"
                    />
                </div>

                <div class="formGroup">
                    <label>Introduction</label>
                    <textarea-autosize v-model="form.intro" :min-height="30" maxlength="1000" />
                </div>

                <div class="formGroup">
                    <label>Contact email address</label>
                    <input type="email" v-model="form.email" maxlength="250" />
                </div>

                <div class="formGroup">
                    <label>Contact telephone</label>
                    <input type="tel" v-model="form.phone" maxlength="250" />
                </div>

                <div class="form-group">
                    <button :disabled="form.busy" class="button half" type="submit" name="button">
                        {{ form.busy ? "Please wait..." : "Update" }}
                    </button>
                    <button
                        @click.prevent="editMode = false"
                        class="button red half"
                        type="button"
                        name="button"
                    >
                        Cancel
                    </button>
                </div>
            </form>

            <div v-else>
                <img
                    v-if="form.image && typeof form.image == 'string'"
                    style="
                        margin-top: 10px;
                        max-width: 100%;
                        margin-bottom: 20px;
                        border-radius: 12px;
                    "
                    :src="imageURL(form.image)"
                />

                <span class="profileTitle">Qualifications</span>
                <span class="profileText large">{{ form.qualifications }}</span>

                <span class="profileTitle">Specialisms</span>
                <span class="profileText large">{{ form.specialisms }}</span>

                <span class="profileTitle">Introduction</span>
                <span class="profileText large">{{ form.intro }}</span>

                <span class="profileTitle">Contact email address</span>
                <span class="profileText large">{{ form.email }}</span>

                <span class="profileTitle">Contact telephone</span>
                <span class="profileText large">{{ form.phone }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import { imageURL } from "@/mixins/imageURL.js";
import objectToFormData from "object-to-formdata";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
import FadeImage from "@/components/App/fade-image";
import { isAndroid } from "mobile-device-detect";
import { dataURLToFile } from "@/mixins/dataURLtoFile.js";
export default {
    name: "",
    components: { AndroidFilePicker, EmptyPlaceholder, FadeImage, XIcon },
    mixins: [imageURL, dataURLToFile],
    created() {
        this.getProfile();

        this.oWebViewInterface.on("fileRecieved-content-profile-image", (imageData) => {
            this.androidFilePickerOpen = false;
            var file = this.dataURLToFile("data:text/plain;base64," + imageData, "aaron.png");
            this.image1 = URL.createObjectURL(file);
            this.form.image = file;
        });
    },
    data() {
        return {
            editMode: false,
            image1: false,
            oWebViewInterface: window.nsWebViewInterface,
            androidFilePickerOpen: false,
            form: new Form({
                image: "",
                qualifications: "",
                specialisms: "",
                intro: "",
                email: "",
                phone: "",
            }),
        };
    },
    methods: {
        openFileAndroid() {
            if (isAndroid) {
                this.androidFilePickerOpen = true;
            }
        },
        addImage() {
            this.image1 = URL.createObjectURL(event.target.files[0]);
            this.form.image = event.target.files[0];
        },
        getProfile() {
            this.form.get("/profile").then((response) => {
                if (!response.data) {
                    this.editMode = true;
                } else {
                    this.form.fill(response.data);
                }
            });
        },
        saveForm() {
            this.form
                .post("/profile", {
                    transformRequest: [
                        function (data) {
                            return objectToFormData(data, { indices: true });
                        },
                    ],
                })
                .then((response) => {
                    this.form.fill(response.data);
                    this.editMode = false;
                    this.$notify("Profile updated");
                });
        },
    },
};
</script>

<style lang="less" scoped>
.info {
    background: #bbf8e0;
}
label {
    color: #89978e !important;
}
.cancel {
    color: white !important;
}
.profileTitle {
    color: #8f9990;
    display: block;
}
.profileText {
    color: white;
    display: block;
    padding-top: 10px;
    padding-bottom: 20px;
    border-bottom: 1px solid #414d47;
    margin-bottom: 20px;
    word-wrap: break-word; /* old name */
    overflow-wrap: break-word;
    display: block;
    white-space: pre-line;
    line-height: 1.5;
    &.large {
        font-size: 20px;
    }
}
.fileInput {
    color: white !important;
    padding: 14px 20px;
    input[type="file"] {
        display: none;
    }
}
</style>
